class SignedUploadUrlFailureException extends Error {
  meta: any

  constructor(field: string, file: Upload.DirectorFile, error: any) {
    super(`Failed to get signed url for ${field}`)

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, SignedUploadUrlFailureException)
    }

    this.name = 'SignedUploadUrlFailureException'
    this.meta = {
      field,
      file,
      error,
    }
  }
}

export default SignedUploadUrlFailureException
